import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/jobHunting',
    name: 'jobHunting',
    component: () => import('../views/jobHunting.vue')
  },
  {
    path: '/JobDetails',
    name: 'JobDetails',
    component: () => import('../views/JobDetails.vue')
  },
  {
    path: '/citys',
    name: 'citys',
    component: () => import('../views/citys.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs.vue')
  },
  {
    path: '/construction',
    name: 'Construction',
    component: () => import('../views/underConstruction.vue')
  },
  {
    path: '/AIInterview',
    name: 'AIInterview',
    component: () => import('../views/AIInterview.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
